import { Component, OnInit } from '@angular/core';
import { ModalController, NavController, ToastController } from '@ionic/angular';

import { Storage } from '@ionic/storage';
import { UtilService } from '../../../service/util.service';
import { UserData } from '../../../providers/user-data';
import { PromotionsService } from '../promotions.service';
import {  Router } from '@angular/router';
import { UserProfile } from '../../../models/user-profile.model';
import { RoleAccess } from '../../../models/role-access.model';
import { UploadPromoComponent } from '../../../component/upload-promo/upload-promo.component';
@Component({
  selector: 'app-promotion-upload',
  templateUrl: './promotion-upload.page.html',
  styleUrls: ['./promotion-upload.page.scss'],
})
export class PromotionUploadPage implements OnInit {

  page = {
    limit: 10,
    count: 0,
    offset: 0,
    orderBy: '',
    orderDir: 'desc'
  };
  rows: any;
  token: any;
  userProfile: UserProfile = new UserProfile();
  promotionList: any;
  filteredData: any;
  counterId: any = '';
  
  roleAccess = new RoleAccess();
  baseUrl:any='';
  urlTemplate ='';
  urlUserGuide ='';
  constructor(
    private storage: Storage,
    private navCtrl: NavController,
    private utilService: UtilService,
    private toastCtrl: ToastController,
    private userData: UserData,
    private promotionService: PromotionsService,
    private router: Router,
    private modalController:ModalController
  ) {}

  ngOnInit() {
  }

  ionViewDidEnter() {
    Promise.all([
      this.storage.get('user_token'),
      this.storage.get('user_profile'),
      this.storage.get('user_menu_access')
    ])
    .then(([token, profile, access]) => {
      if(token) {
        this.token = token;
        this.userProfile = new UserProfile(profile);
        this.roleAccess = this.userData.checkAccess(this.router.url, access, this.userProfile);
        if(!this.roleAccess || this.roleAccess.view!='1'){
          this.toastCtrl.create({ duration: 2000, message: 'You Are Not Allowed to Access this Page' }).then(t => t.present());
         // this.navCtrl.navigateForward(['/']);
        }
        else{
        //  this.pageCallback({ offset: this.page.offset });
        }
        this.pageCallback({ offset: this.page.offset });
      } else {
        this.toastCtrl.create({ duration: 2000, message: 'Silahkan login terlebih dahulu.' }).then(t => t.present());
        this.navCtrl.navigateForward(['/login']);
      }
    });
  }

  pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
    this.page.offset = pageInfo.offset;
    this.reloadTable();
  }
  
  sortCallback(sortInfo: { sorts: { dir: string, prop: string }[], column: {}, prevValue: string, newValue: string }) {
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    this.reloadTable();
  }

  reloadTable() {
    this.utilService.loadingPresent('Harap tunggu...')
    .then(() => {
      let offset = this.page.offset + 1;
      let options = {
        "token": this.token,
        "page": offset.toString(),
        "counter_id": this.userProfile.counter_id !== 0 ? this.userProfile.counter_id : this.userProfile.counter_id_list
      };

      this.promotionService.getPromotionUpload(options).subscribe((response) => {
        console.log(response);
        this.utilService.loadingDismiss();
        this.page.count = response.results.total;
        this.rows = response.results.data;
        this.filteredData = response.results.data;
        this.promotionList = response.results.data;
        this.urlTemplate = response.template;
        this.urlUserGuide = response.user_guide;
      }, (err) => {
        this.utilService.loadingDismiss();
        console.log(err);
        if(err.error.error === 'token_expired') {
          this.userData.logout().then(() => {
            this.toastCtrl.create({ duration: 2000, message: 'Token telah expired. Silahkan login kembali' }).then(t => t.present());
            this.navCtrl.navigateForward(['/login']);
          });
        } else {
          this.toastCtrl.create({ duration: 2000, message: 'Gagal terhubung ke server' }).then(t => t.present());
        }
      });
    });
  }
 
  
  
  async openUploadNewPromo(index: any, action: any) {
    const modal = await this.modalController.create({
      component: UploadPromoComponent,
      componentProps: {
        'username': this.userProfile.username,
        'id' :0,
        'action':'add_promo',
        'template':this.urlTemplate,
        'userGuide':this.urlUserGuide
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      console.log(modelData);
      
      if(modelData.data[0].id!=''){
        this.reloadTable();
      }
    });

    return await modal.present();
  }
  
  async goToDetail(id: any, action: any) {
    const modal = await this.modalController.create({
      component: UploadPromoComponent,
      componentProps: {
        'username': this.userProfile.username,
        'id' : id,
        'action':'view_detail'
      },
      backdropDismiss: false
    });

    modal.onDidDismiss().then((modelData) => {
      console.log(modelData);
      
      if(modelData.data[0].id!=''){
        this.reloadTable();
      }
    });

    return await modal.present();
  }
}
